import type { RicosTheme } from './../../ricos-types';

import type { WixRicosTheme } from '../WixRicosTypes';
import { withLiveSiteStyle } from './useLiveSiteStyle';
import { withNativeStyle } from './useNativeStyle';
import { withWixStyle } from './useWixStyle';

type WixThemeStrategy = (WixRicosTheme?: WixRicosTheme, isBmPlatform?: boolean) => RicosTheme;

export const themeStrategy: WixThemeStrategy = (
  { useWixStyles, useNativeStyles, ...rest } = {},
  isBmPlatform = false
) => {
  return useNativeStyles
    ? withNativeStyle(rest)
    : useWixStyles ?? isBmPlatform
    ? withWixStyle(rest)
    : withLiveSiteStyle(rest);
};
